export default {    
    form: {        
        fields: {            
            condicao: {
                fields: {
                    firstField: {
                        label: "Field",
                        description: "What will be the field to validate."
                    },
                    rule: {
                        label: "Condition",
                        description: "What will be the Condition."
                    },
                    secondField: {
                        label: "Value",
                        description: "What will be the value to compare."
                    },
                    thirdField: {
                        label: "Other Amount",
                        description: "What will be the other value to compare."
                    },
                    fourthField: {
                        label: "Result",
                        description: "What will be the value of the result."
                    }
                },
                DB_fields: {                    
                    value_quantity_value: "Result value"
                },
                rules: {
                    isNull: "Is empty",
                    isNotNull: "It is not empty",
                    bigger: "Bigger then",
                    biggerOrEqual: "Greater than or equal to",
                    less: "Less than",
                    lessOrEqual: "Less than or equal to",
                    equal: "it's the same as",
                    different: "It is other than",
                    between: "Its between",
                    notBetween: "Is not between"
                }
            }
        },
        buttons: {
            adicionar_condicao: 'Add Condition',
            remover_condicao: 'Remove Condition',
            salvar: 'Save Condition'
        },
        create: {
            success: "Condition created successfully!",
            error: "Error creating condition!"
        },
        update: {
            success: "Condition successfully edited!",
            error: "Error editing condition!"
        }
    }
}
